<template>
  <div>
    <div class="flex">
      <SideBar />
      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl overflow-x-auto overflow-y-auto heightfix relative"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <!-- Loading Overlay -->
        <div 
          v-if="isLoading" 
          class="absolute inset-0 bg-white bg-opacity-90 flex items-center justify-center z-10 rounded-3xl"
        >
          <div class="text-center">
            <div class="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-blue-500 mb-4"></div>
            <p class="text-gray-600">Loading content...</p>
          </div>
        </div>
        
        <iframe
          ref="scormIframe"
          src="/pages/scormcontent/index.html"
          width="100%"
          height="100%"
          frameborder="0"
          @load="onIframeLoad"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/Instructor/SideBar.vue";

export default {
  components: {
    SideBar,
  },

  data() {
    return {
      isLoading: true,
    };
  },

  mounted() {
    window.IsLmsPresent = function () {
      return true;
    };
    
    this.loadTimeout = setTimeout(() => {
      if (this.isLoading) {
        this.isLoading = false;
        console.warn('Iframe loading timeout');
      }
    }, 10000); 
  },

  methods: {
    onIframeLoad() {
      this.isLoading = false;
      if (this.loadTimeout) {
        clearTimeout(this.loadTimeout);
      }
    },
  },

  beforeDestroy() {
    if (this.loadTimeout) {
      clearTimeout(this.loadTimeout);
    }
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.animate-spin {
  animation: spin 1s linear infinite;
}
</style>